import validate from "/usr/src/app/content/n3-redirections-service-f59df12b-8fd7-4669-9092-8422e20f983c/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-redirections-service-f59df12b-8fd7-4669-9092-8422e20f983c/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}